import {RatingsError} from './RatingsError.js'

export class EmptyTokenRatingsError extends RatingsError {}
